import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth, db } from "./firebaseConfig"; 
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Agents from "./pages/Agents";
import Regulations from "./pages/Regulations";
import Contact from "./pages/Contact";
import ExchangeRatePage from "./pages/ExchangeRatePage";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import AdminDashboard from "./pages/Admin/AdminDashboard";

import "./App.css";

export default function App() {
  const [currentUserRole, setCurrentUserRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setLoading(true); // Start loading while we fetch role
      if (user) {
        console.log("User detected:", user.email, "UID:", user.uid);
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const role = userDoc.data().role;
            console.log("Firestore Role Found:", role);
            setCurrentUserRole(role);
          } else {
            console.warn("NO FIRESTORE DOCUMENT FOUND for this UID!");
            setCurrentUserRole("client"); 
          }
        } catch (error) {
          console.error("Firestore Error:", error);
          setCurrentUserRole(null);
        }
      } else {
        console.log("No user logged in.");
        setCurrentUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-spinner" style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Verifying Permissions...</h2>
      </div>
    );
  }

  return (
    
    <Router>
      <Routes>
        
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/exchange-rate" element={<ExchangeRatePage />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />

        {/* --- Protected Admin Route --- */}
        <Route 
          path="/admin" 
          element={
            currentUserRole === "admin" ? (
              <AdminDashboard />
            ) : (
              // If not an admin, we show a clean redirect
              <Navigate to="/signin" replace />
            )
          } 
        />
        
        {/* Handle 404s */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}